'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _droppableDimensionPublisher = require('./droppable-dimension-publisher');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_droppableDimensionPublisher).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/droppable-dimension-publisher/index.js
// module id = 3266
// module chunks = 0